/**
 * TMS action-event tracking (Amplitude + GA via trackUnifiedEvent).
 *
 * Cardinality discipline (mirrors features/billing/tms/analytics.ts):
 *   - Only bounded dimensions: enums, booleans, fixed strings.
 *   - No emails / IDs / free text / raw dates.
 * Every call swallows errors — analytics must never break the page.
 */

import { AnalyticsEvent, EventCategory } from './events'
import { PropertyValue } from './types'
import { trackUnifiedEvent } from './unified'

export const trackTmsAction = (action: AnalyticsEvent, props?: Record<string, PropertyValue>): void => {
    try {
        trackUnifiedEvent({ action, category: EventCategory.TMS, ...props })
    } catch {
        /* analytics must never break the page */
    }
}
